import { useCallback } from "react";
import { useVoiceChatStore } from "../store/voice-chat-store";

/**
 * Voice chat ile chat feature'ını entegre eden hook
 *
 * 🚧 STUB: Eski implementasyon legacy chat-store (`chats`/`addMessage`) ve
 * non-streaming `sendQuery` API'sine bağımlıydı; o katman kaldırıldı.
 * Voice chat sıfırdan yeniden yazılırken transcript'in streaming akışına
 * (`useStreamingChat.sendStreamingMessage`) bağlanması gerekiyor.
 */
export const useVoiceChatIntegration = () => {
  const { transcript, setIsWaitingForResponse } = useVoiceChatStore();

  const handleTranscriptSubmit = useCallback(
    async (text?: string) => {
      const transcriptToSubmit = text || transcript;
      if (!transcriptToSubmit?.trim()) return;

      console.warn(
        "Voice chat entegrasyonu yeniden yazılıyor; transcript gönderilmedi:",
        transcriptToSubmit
      );
      setIsWaitingForResponse(false);
    },
    [transcript, setIsWaitingForResponse]
  );

  return {
    handleTranscriptSubmit,
  };
};
